module.exports = __webpack_public_path__ + "static/media/select-stage.104e6fd1.mp3";